import React, { useState } from 'react';
import { Field } from '@gumtree/ui-library/src';
import { partialMatch, sortListByProperty } from '@gumtree/shared/src/util/list-of-objects';

import type { FilterItem, FilterKey, FilterValue } from '../../../types';
import DefaultFilter from '../default-filter';
import { StyledFieldIcon, StyledInputBlock } from './index.style';

const isUseSearch = (searchQuery) => searchQuery.length >= 2;

export const SearchableFilter = ({
    filterKey,
    filterItemsRaw,
    selectedFilterValue,
    isStateful,
    placeholder,
}: {
    filterKey: FilterKey;
    filterItemsRaw: FilterItem[];
    selectedFilterValue: FilterValue;
    isStateful: boolean;
    placeholder?: string;
}) => {
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [isShowAll, setIsShowAll] = useState(false);

    const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setSearchQuery(value);
    };

    const itemsToShow = isUseSearch(searchQuery)
        ? partialMatch(searchQuery, filterItemsRaw, 'label')
        : isShowAll
        ? filterItemsRaw
        : sortListByProperty(filterItemsRaw, 'abundance', false);

    return (
        <>
            <StyledInputBlock>
                <Field
                    id={`searchable-filter-${filterKey}`}
                    aria-label={filterKey}
                    value={searchQuery}
                    onInput={onInput}
                    placeholder={placeholder}
                />
                <StyledFieldIcon type="magnifying-glass" size="medium-small" />
            </StyledInputBlock>
            <DefaultFilter
                filterKey={filterKey}
                shortListLength={5}
                filterItemsRaw={itemsToShow}
                selectedFilterValue={selectedFilterValue}
                isStateful={isStateful}
                onExpandToggle={(newToggleState) => setIsShowAll(newToggleState)}
            />
        </>
    );
};

export default SearchableFilter;
